import { useEffect, useState } from "react";
import { fetchSTRemnantData } from "../../../api/homeApi";
import { toast } from "react-toastify";



function useSTRemanentLife(filter, currentDateISO, maxExpiryDateISO) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!filter) return; // avoid unnecessary calls if filter is empty

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchSTRemnantData(filter, currentDateISO, maxExpiryDateISO);
        setData(response); // assuming response has a `data` field
      } catch (err) {
        toast.error("Cannot fetch CMLs with Shortest Remanent Life");
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [JSON.stringify(filter)]);
  return { data, loading, error };
}

export default useSTRemanentLife;